module.exports = __webpack_public_path__ + "img/Gasser-Klimagasser-og-Spraydåser.16888bcc.jpg";